/* eslint camelcase: "off" */

import { postToURL } from 'amkit3-modules/utils/ajax'
import { STATISTIC_METRIC } from 'amkit3-modules/utils/services/urls'
import { getLogger } from 'amkit3-modules/utils/log4js'
const logger = getLogger('utils/services/statistic/huya/metric')

function toXCodeArray(str) {
  let x = []
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i)
    if (c < 0x80) x.push(c)
    else if (c < 0x800) {
      x.push(0xc0 | (c >> 6), 0x80 | (c & 0x3f))
    } else if (c < 0xd800 || c >= 0xe000) {
      x.push(0xe0 | (c >> 12), 0x80 | ((c >> 6) & 0x3f), 0x80 | (c & 0x3f))
    } else {
      i++
      c = 0x10000 + (((c & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff))
      x.push(
        0xf0 | (c >> 18),
        0x80 | ((c >> 12) & 0x3f),
        0x80 | ((c >> 6) & 0x3f),
        0x80 | (c & 0x3f),
      )
    }
  }
  return x
}

function xEncode(data, key) {
  let r = ''
  let t = ''
  let o = ''
  let i = 0
  let j = 0
  let m = 0
  let mm = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
  let c1, c2, c3, e1, e2, e3, e4
  let dArray = toXCodeArray(data)
  for (i = dArray.length - 1, j = 0; i >= 0; i--) {
    t = dArray[i] ^ key.charCodeAt(j) ^ m
    r = r + String.fromCharCode(t)
    j = ++j % key.length
    m = t
  }
  i = 0
  while (i < r.length) {
    c1 = r.charCodeAt(i++)
    c2 = r.charCodeAt(i++)
    c3 = r.charCodeAt(i++)
    e1 = c1 >> 2
    e2 = ((c1 & 3) << 4) | (c2 >> 4)
    e3 = ((c2 & 15) << 2) | (c3 >> 6)
    e4 = c3 & 63
    if (isNaN(c2)) {
      e3 = e4 = 64
    } else if (isNaN(c3)) {
      e4 = 64
    }
    o = o + mm.charAt(e1) + mm.charAt(e2) + mm.charAt(e3) + mm.charAt(e4)
  }
  return o
}

export const video_quality_kadun = (
  yyuid,
  session_id,
  mid,
  vid,
  page_add,
  isflash,
  video_add,
  os,
  sre,
  status,
  domain,
  extdesc,
) => {
  let jsonData = {
    ua: 'vhuyaplayer&1.0.0',
    uid: yyuid,
    sguid: '',
    m: [
      {
        name: 'video_quality_kadun',
        its: Math.floor(+new Date() / 1000),
        dim: {
          session_id: session_id,
          mid: mid,
          yyuid: yyuid,
          vid: vid,
          page_add: page_add,
          isflash: isflash,
          video_add: video_add,
          os: os,
          sre: sre,
          status: status,
          domain: domain,
          ua: window.navigator.userAgent,
        },
        field: {},
        exlog: {
          extdesc: extdesc,
        },
      },
    ],
  }

  logger.debug('video_quality_kadun', jsonData)

  let timestamp = new Date().getTime() + ''

  postToURL(STATISTIC_METRIC + timestamp, xEncode(JSON.stringify(jsonData), timestamp))
}

export default {
  video_quality_kadun,
}
